import React, {useEffect, useState} from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, {tableCellClasses} from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';
import {Link, useHistory} from "react-router-dom";
import axios from "axios";
import {API_PATH} from "../../components/const";
import {toast} from "react-toastify";
import {Button, Flex, Modal, Popover, Spin} from "antd";
import EmployeFilter from "./EmployeFilter";


const Employees = () => {
    const [current, setCurrent] = useState(1);
    let history = useHistory()
    const [users, setUsers] = useState([])
    const [usersObj, setUsersObj] = useState({
        page: 1
    })
    const [usersObjSize, setUsersObjSize] = useState(1)
    const [selectUser, setSelectUsers] = useState(null)
    const [isModalOpen, setIsModalOpen] = useState(false);
    const dateFormat = 'YYYY-MM-DD';
    const [building_id, setbuilding_id] = useState("")
    const [parents_id, setparents_id] = useState("")
    const [department_id, setdepartment_id] = useState("")
    const [age, setAge] = useState("")
    const [position, setPosition] = useState("")
    const [gender, setGender] = useState("")
    const [mySpin, setMySpin] = useState(false)
    const [perList, setPerList] = useState([])

    const getMe = () => {
        axios.get(API_PATH + "user/me", {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res => {
                setPerList(res.data?.permission_actions)
            })
    }

    const showModalDelete = (e) => {
        setSelectUsers(e)
        setIsModalOpen(true);
    };
    const handleCancelDelete = () => {
        setIsModalOpen(false);
    };
    const createPage = () => {
        history.push("/main/hr-admin/employees/profile/create")
    }
    const editPage = (id) => {
        history.push("/main/hr-admin/employees/profile/edit/" + id)
    }
    const getUsers = () => {
        axios.get(API_PATH + "user/company/" + localStorage.getItem('id') + "/user/all?page=" + usersObjSize, {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res => {
                setUsers(res.data?.items)
                setUsersObj(res.data)

            })
            .catch(err => {
                toast.error("Ошибка")
            })
    }

    const handleOkDelete = (e) => {
        axios.delete(API_PATH + "user/company/" + localStorage.getItem('id') + "/delete/user/" + selectUser, {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res => {
                setIsModalOpen(false);
                toast.success("Успех удален")
                getUsers()
            })
    };

    const changePagination = (current, size) => {
        setUsersObjSize(size)
        if (position.length > 0 || age.length > 0 || gender.length > 0 || department_id.length > 0 || building_id.length > 0) {
            axios.get(API_PATH + "user/company/" + localStorage.getItem('id') + "/user/all?page=" + size + (building_id ? "&building_id=" + building_id + "&" : "") + (department_id ? "department_id=" + department_id : "") + (gender ? "&gender=" + gender : "") + (position ? "&position=" + position : "") + (age ? "&dob=" + age : ""), {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
                .then(res => {
                    setUsers(res.data?.items)
                    setUsersObj(res?.data)
                })
                .catch(err => {
                    toast.error("Ошибка")
                })
        } else {
            axios.get(API_PATH + "user/company/" + localStorage.getItem('id') + "/user/all?page=" + size, {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
                .then(res => {
                    setUsers(res.data?.items)
                    setUsersObj(res?.data)
                })
                .catch(err => {
                    toast.error("Ошибка")
                })
        }
    }

    useEffect(() => {
        getUsers()
        getMe()
        if (localStorage.getItem("task_id")) {
            // setInterval(()=> {
            axios.get(API_PATH + "company/" + localStorage.getItem('id') + "/device_management_async/delete_blacklist_batch/" + localStorage.getItem("task_id"), {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
                .then(res => {
                    if (res?.data?.task_status === "SUCCESS") {
                        setMySpin(false)
                    } else {
                        setMySpin(true)
                    }
                })
            // }, 5000)
        }

    }, []);

    return (
        <div className="employees-pair">
            <div className="employees-header">
                <div className="d-flex justify-content-between align-items-center">
                    <div className="left-head">
                        <h6>Cотрудники</h6>
                        <p>Управление сотрудниками</p>
                    </div>
                    <div className="right-head">
                        {/*<button className="upload-btn font-family-medium ml-16 mr-16"><img src="/icon/upload.svg"/> Экспорт в Excel</button>*/}
                        {
                            mySpin
                                ?
                                <div className="d-flex align-items-center justify-content-end  mr-16">
                                    <Spin style={{width: "40px", height: "16px"}}
                                          className="d-flex align-items-center justify-content-center"/>
                                    <p className="text-white m-0">Данные загружаются...</p>
                                </div>
                                :
                                ""
                        }
                        <a className="btn btn-success mr-8"
                           href={API_PATH + "user/company/" + localStorage.getItem("id") + "/download/example-xlsx-file"}
                           download>Скачать шаблон</a>
                        <button className="add-btn font-family-medium mr-8"
                                onClick={() => history.push("/main/hr-admin/employees/import-excel")}>Импортировать
                            Excel
                        </button>
                        {
                            perList?.filter(item => item === "add_employee").length > 0
                                ?
                                <button className="add-btn font-family-medium" onClick={createPage}><img
                                    src="/icon/plus.svg"/> Добавить новое</button>
                                :
                                ""
                        }
                    </div>
                </div>
            </div>

            <EmployeFilter
                setUsers={setUsers}
                setUsersObj={setUsersObj}
                setGender={setGender}
                setAge={setAge}
                age={age}
                building_id={building_id}
                department_id={department_id}
                gender={gender}
                position={position}
                setPosition={setPosition}
                setdepartment_id={setdepartment_id}
                setbuilding_id={setbuilding_id}
                parents_id={parents_id}
                setparents_id={setparents_id}
                getUsers={getUsers}
            />


            <div className="emp-table">
                <TableContainer component={Paper}>
                    <Table sx={{minWidth: 650}} aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <TableCell className="pl20 table-head">№</TableCell>
                                <TableCell className="  table-head">Имя и фамилия</TableCell>
                                <TableCell className="table-head" align="left">Логин</TableCell>
                                <TableCell className="table-head" align="left">Отдел</TableCell>
                                <TableCell className="table-head" align="left">Должность</TableCell>
                                <TableCell className="table-head" align="left">Здание</TableCell>
                                {/*<TableCell className="table-head"  align="left">25.12.2023</TableCell>*/}
                                <TableCell className="pr20 table-head" align="right">Действие</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {users.map((item, index) => (
                                <TableRow
                                    key={item?.name}
                                    sx={{'&:last-child td, &:last-child th': {border: 0}}}
                                >
                                    <TableCell className="pl20" scope="row">
                                        <div className="tabel-item">
                                            {
                                                (usersObj?.page === 1 ? 0 : (usersObj?.page - 1) * 20) + index + 1
                                            }
                                        </div>
                                    </TableCell>
                                    <TableCell scope="row">
                                        <div className="tabel-item">
                                            <img src={item?.image} alt="img" className="mr-8" style={{
                                                width: "40px",
                                                height: "40px",
                                                objectFit: "cover",
                                                borderRadius: "50%"
                                            }}/>
                                            {/*{item.first_name + " " + item.last_name}*/}
                                            <Popover content={item?.first_name + " " + item?.last_name}>
                                                {/*<Button type="primary">Hover me</Button>*/}
                                                {item?.last_name + " " + item.first_name?.slice(0, 1)}
                                            </Popover>
                                        </div>

                                    </TableCell>
                                    <TableCell align="left">
                                        <div className="tabel-item">
                                            {item?.username}
                                        </div>
                                    </TableCell>
                                    <TableCell align="left">
                                        <div className="tabel-item">
                                            {item?.department?.department_title}
                                        </div>
                                    </TableCell>
                                    <TableCell align="left">
                                        <div className="tabel-item">
                                            {item?.position}
                                        </div>
                                    </TableCell>
                                    <TableCell align="left">
                                        <div className="tabel-item">
                                            {item?.building?.name}
                                        </div>
                                    </TableCell>
                                    {/*<TableCell align="left">*/}
                                    {/*    <div className="tabel-item">*/}
                                    {/*        8 часов 12 минуты*/}
                                    {/*    </div>*/}
                                    {/*</TableCell>*/}
                                    <TableCell className="  con-btns-all" align="right">
                                        <div className="tabel-item tabel-item-controls">
                                            {
                                                perList?.filter(item => item === "delete_employee").length > 0
                                                    ?
                                                    <button className="t-delete-btn font-family-medium"
                                                            onClick={() => showModalDelete(item?.id)}>Удалить
                                                    </button>
                                                    :
                                                    ""
                                            }
                                            {
                                                perList?.filter(item => item === "change_employee").length > 0
                                                    ?
                                                    <button className="t-edit-btn font-family-medium"
                                                            onClick={() => editPage(item?.id)}>Изменить</button>
                                                    :
                                                    ""
                                            }
                                        </div>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
            <Modal title="Внимание!"
                   open={isModalOpen}
                   onCancel={handleCancelDelete}
                   footer={[
                       <Button key="submit" type="default" onClick={handleCancelDelete}>
                           Отменить
                       </Button>,
                       <Button key="submit" type="danger" className="my-red-canc" onClick={handleOkDelete}>
                           Да, удалить
                       </Button>
                   ]}
            >
                <p className="pt-2 pb-2 text-white">Вы уверены, что удалите этого пользователя? Это невозможно
                    отменить</p>
            </Modal>

            <div className="pag-bottom">
                <Stack spacing={2}>
                    <Pagination count={usersObj?.pages} total={usersObj?.total} current={current}
                                onChange={changePagination} shape="rounded"/>
                </Stack>
            </div>
        </div>
    );
};

export default Employees;